import { useLocalStorageState } from "@outschool/local-storage";
import { useMemo } from "react";

export const PITCH_PAGE_QUIZ_COMPLETED_TRACKING_NAME =
  "HAS_COMPLETED_ONBOARDING_QUIZ";

export function useHasCompletedOnboardingQuiz(): boolean {
  const [hasCompletedQuiz] = useLocalStorageState(
    PITCH_PAGE_QUIZ_COMPLETED_TRACKING_NAME,
    false
  );

  return useMemo(() => {
    return hasCompletedQuiz;
  }, [hasCompletedQuiz]);
}
